import syncFields from '../_syncfields.js';
import reportModified from '../_reportmodified.js';
import assign from '../../_helpers/assign.js';
import withLengthOptions from '../_withlengthoptions.js';
// creates removing method and returns it (pop, shift, pop_, shift_)
export default function createRemovingMethod(name, hasOptions) {
  return function pseudoNativeMethod(givenEventOptions) {
    var _this = this;
    syncFields(this);
    if (!this.length) {
      return undefined;
    }
    // call original method
    var returns = withLengthOptions(this, hasOptions ? givenEventOptions : null, function () {
      return Array.prototype[name].call(_this);
    });
    var eventOptions = {
      method: name,
      self: this,
      added: [],
      removed: [returns]
    };
    // extend event options by custom event options if they are given
    if (hasOptions) {
      if (givenEventOptions && typeof givenEventOptions === 'object') {
        assign(eventOptions, givenEventOptions);
      }
    }
    reportModified(this, eventOptions);
    return returns;
  };
}